module.exports = __webpack_public_path__ + "static/mui-1260b2c4b13830286a037199956ece6f.png";